import styled from "styled-components";
import Sizes from "../../Assets/Sizes";

const CenterContainer = styled.div`
  z-index: 1;
  text-align: center;
  width: 100%;
`;

const FlexContainer = styled.div`
	display: flex;
	align-items: center;
	gap: ${ Sizes.defaultPadding };
`;

const ColumnFlexContainer = styled(FlexContainer)`
	flex-direction: column;
	gap: ${ Sizes.mediumPadding };
	
`;

const VerticalSpace = styled.div`
	width: 100%;
	height: ${ Sizes.defaultPadding };
`;


const TextContainer = styled.div`
  width: 100%;
  padding-left: ${ Sizes.defaultPadding };
  padding-right: ${ Sizes.defaultPadding };
  flex-grow: 1;
  // margin-top: -150px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  *:focus {
    outline: none;
  }
`;

const TextWithIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PhoneInputWrapper = styled.div`
	width: 100%;
	display: flex;
`;


export {
	CenterContainer,
	TextContainer,
	TextWithIconWrapper,
	PhoneInputWrapper,
	FlexContainer,
	ColumnFlexContainer,
	VerticalSpace
}
